import {FC, HTMLAttributes} from 'react'

export const CircleIcon: FC<{size?: number; fill?: string} & HTMLAttributes<SVGSVGElement>> = ({
    size = 16,
    fill = 'currentColor',
    ...props
}) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
        <g clipPath="url(#clip0_4219_1304)">
            <path
                d="M8.00016 14.6673C11.6821 14.6673 14.6668 11.6825 14.6668 8.00065C14.6668 4.31875 11.6821 1.33398 8.00016 1.33398C4.31826 1.33398 1.3335 4.31875 1.3335 8.00065C1.3335 11.6825 4.31826 14.6673 8.00016 14.6673Z"
                stroke={fill}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_4219_1304">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)
